/*
  Sticky add-to-cart bar — reveal on scroll.

  Owns no purchase logic. It mirrors the real in-page button and, when tapped,
  either drives that button or sends the shopper to the step that is blocking
  them. Every string it shows is copied from the DOM the switcher already
  maintains, so there is one source of truth for price, label and enabled state.
*/
(function () {
  var bar = document.querySelector('[data-cc-sticky-atc]');
  if (!bar) return;

  var priceOut = bar.querySelector('[data-cc-sticky-price]');
  var statusOut = bar.querySelector('[data-cc-sticky-status]');
  var labelOut = bar.querySelector('[data-cc-sticky-label]');

  var debug = /[?&]ccdebug=1\b/.test(window.location.search);

  var realBtn = document.querySelector('[data-cc-atc]');
  var realText = document.querySelector('[data-cc-atc-text]');
  var realPrice = document.querySelector('[data-cc-price]');
  if (!realBtn || !realText || !realPrice) return;

  /* ---------------------------------------------------------------- reveal */
  //
  // One full screen of scrolling, and not into the footer. That is the whole
  // rule.
  //
  // It was gated on the gallery leaving view before that, and on the buy button
  // before that again. Both were too clever and both were wrong on a real
  // phone: the button version was state-dependent, because opening the chart
  // panel changes the page height, and the gallery version kept the bar hidden
  // through the entire picker area. window.innerHeight is device-relative, so
  // this is not a pixel constant, and it depends on no element's geometry and
  // on no display:none behaviour across breakpoints. There is nothing left to
  // be wrong about.
  var footerReached = false;
  var pastFold = false;

  function threshold() {
    return window.innerHeight;
  }

  function apply() {
    var on = pastFold && !footerReached;
    bar.classList.toggle('is-revealed', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (debug) renderDebug();
  }

  // Boolean latch, not requestAnimationFrame: frames are withheld in exactly
  // the conditions this has to keep working in, and the DOM is only touched on
  // a transition rather than on every scroll event.
  function onScroll() {
    var now = window.scrollY > threshold();
    if (now === pastFold) {
      if (debug) renderDebug();
      return;
    }
    pastFold = now;
    apply();
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // The footer stand-down is unchanged. Measured on DEV: the last 88px of the
  // document, which is what this bar covers, holds the copyright line and the
  // Privacy and Terms links. Scoped to the legal strip rather than the whole
  // <footer>, which is 467px tall. No page padding, which would shift layout.
  var legal = document.querySelector('.footer-cc__legal');
  if (legal) {
    new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        if (!e) return;
        footerReached = e.isIntersecting;
        apply();
      },
      { threshold: 0 }
    ).observe(legal);
  }

  /* ------------------------------------------------------------- next step */
  // Generic, not per-block: any picker that renders a [data-cc-slots] row
  // exposes its progress as filled vs total slot buttons. Works for birthstone,
  // initial and name pickers without knowing which is on the page.
  function nextStep() {
    var rows = document.querySelectorAll('#cc-product-form [data-cc-slots]');
    for (var i = 0; i < rows.length; i++) {
      var slots = rows[i].querySelectorAll('button');
      if (!slots.length) continue;
      var filled = 0;
      var firstEmpty = null;
      for (var j = 0; j < slots.length; j++) {
        if (slots[j].className.indexOf('--filled') > -1) filled++;
        else if (!firstEmpty) firstEmpty = slots[j];
      }
      if (firstEmpty) return { el: firstEmpty, filled: filled, total: slots.length };
    }

    // A picker is rendered but has not been given a count yet: the count
    // selector is the blocking step.
    var count = document.querySelector('#cc-product-form [class*="count-btn"], #cc-product-form [class*="count-bt"]');
    if (count) return { el: count, filled: 0, total: 0 };

    // Anything else the shopper still has to fill in.
    var fields = document.querySelectorAll('#cc-product-form textarea, #cc-product-form input[type="text"], #cc-product-form input[type="file"]');
    for (var k = 0; k < fields.length; k++) {
      if (fields[k].offsetParent !== null && !String(fields[k].value || '').trim()) {
        return { el: fields[k], filled: 0, total: 0 };
      }
    }

    // Last resort. There is always somewhere to send them - never a dead tap.
    return { el: document.querySelector('[data-cc-customization]') || realBtn, filled: 0, total: 0 };
  }

  /* ------------------------------------------------------------------ sync */
  function sync() {
    priceOut.textContent = realPrice.textContent.trim();
    labelOut.textContent = realText.textContent.trim();

    var blocked = realBtn.disabled;
    bar.classList.toggle('is-blocked', blocked);

    if (blocked) {
      var step = nextStep();
      if (step.total > 1) {
        statusOut.textContent = step.filled + ' of ' + step.total + ' chosen';
        statusOut.hidden = false;
      } else {
        statusOut.hidden = true;
      }
    } else {
      statusOut.hidden = true;
    }
  }

  // The switcher mutates these nodes in place; it never replaces them. Watching
  // them is what keeps price and label correct as the configuration changes,
  // including the stone count changing the price.
  var mo = new MutationObserver(sync);
  mo.observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
  mo.observe(realText, { childList: true, characterData: true, subtree: true });
  mo.observe(realPrice, { childList: true, characterData: true, subtree: true });

  // Slot fills do not touch the button when a gate is already failing, so listen
  // for the picker events too. One handler, all block types.
  [
    'cc:birthstones-changed', 'cc:initials-changed', 'cc:engraving-changed',
    'cc:birthflowers-changed', 'cc:name-birthstone-changed', 'cc:zodiac-changed',
    'cc:date-changed', 'cc:photo-changed', 'cc:number-changed',
    'cc:dropdown-changed', 'cc:toggle-changed', 'cc:textfields-changed'
  ].forEach(function (name) {
    document.addEventListener(name, sync);
  });

  sync();

  /* ----------------------------------------------------------------- debug */
  // ?ccdebug=1 only. Throwaway diagnostics so mobile behaviour stops being a
  // guess. Renders at the TOP of the screen because the bar owns the bottom.
  var debugEl = null;
  function renderDebug() {
    if (!debugEl) return;
    debugEl.textContent =
      'scrollY ' + Math.round(window.scrollY) +
      ' | innerH ' + window.innerHeight +
      ' | threshold ' + Math.round(threshold()) +
      ' | pastFold ' + pastFold +
      ' | footer ' + footerReached +
      ' | revealed ' + bar.classList.contains('is-revealed');
  }
  if (debug) {
    debugEl = document.createElement('div');
    debugEl.setAttribute('data-cc-sticky-debug', '');
    debugEl.style.cssText =
      'position:fixed;top:0;left:0;right:0;z-index:2147483000;' +
      'background:#0D3934;color:#FBFAF7;font:11px/1.5 monospace;' +
      'padding:6px 8px;text-align:center;pointer-events:none;';
    document.body.appendChild(debugEl);
  }

  // Set the initial state now, in case the browser restored a scroll position.
  onScroll();
  apply();

  /* ------------------------------------------------------------------- tap */
  // Delegated from document. The PDP section is not re-rendered today - the
  // switcher holds direct references and mutates in place, and the only Section
  // Rendering call on this page re-renders CART sections, not this one - but
  // delegation costs nothing and survives that changing.
  //
  // Attached once at init, never inside the event that reveals the bar.
  document.addEventListener('click', function (event) {
    var hit = event.target && event.target.closest && event.target.closest('[data-cc-sticky-btn]');
    if (!hit) return;

    if (!realBtn.disabled) {
      // Reuse the real button so the existing handler, the drawer flow and the
      // cart properties all apply. No duplicated add-to-cart logic here.
      realBtn.click();
      return;
    }

    var step = nextStep();
    if (!step.el) return;
    step.el.scrollIntoView({ block: 'center', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    // Focus after the scroll is under way. Deferred by a task, not a frame:
    // timers still fire when frames are withheld.
    setTimeout(function () {
      if (typeof step.el.focus === 'function') step.el.focus({ preventScroll: true });
    }, 0);
  });

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
})();
